import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.3/js/sparta-events-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.2/js/sparta-global-functions-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.4/js/sparta-store-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import DataAssetLoader from "utilities/suits/data-asset-loader/2.1.0/js/data-asset-loader";
/* global boaBrowserSupportCMS DataAssetLoader spartaEventsUtility spartaGlobalFunctions spartaStoreUtility */

/**
 * @module
 * @name sparta-browser-support-utility
 * @desc export a singleton instance of SpartaBrowserSupportUtility class
 * @version 4.1.0
 */

const defaults = {
  userAgent: null,
  showMessage: true, // turn off message
  useAjax: false, // use ajax to get updated browser rules
  debug: false, // enable debugging
  testMode: false, // test mode; turns on messaging on command
  isLocal: (spartaStoreUtility.getData('environment') === 'LOCAL'),
  useSessionStorage: spartaStoreUtility.getData('useSessionStorage'), // Is Session Storage Available
  ua: '',
  platform: '',
  boaBrowserShowNoticeCookie: '',
  boaBrowserTestCookie: '',
};

const EVENTS = {
  LOADED: 'LOADED.SpartaBrowserSupportUtility',
};

const VERSIONS = {
  BLOCKED_IE: 9,
  BLOCKED_FF: 44,
  EOL_IE: 10,
  EOL_CHROME: 55,
  EOL_FF: 50,
  EOL_SAFARI: 9.1,
};

const TLS_COOKIE_NAME = 'TLS';
const TLS_COOKIE_VALUE_VERSION_PREFIX = 'TLSv';
const MIN_SUPPORTED_TLS_VERSION = 1.2;

let instance;

/**
 * @class SpartaBrowserSupportUtility
 * @classdesc Class for global implementation of browser detection
 */
class SpartaBrowserSupportUtility {
  /**
   * @method
   * @name constructor
   * @desc Initialize an instance of our browser support class
   */
  constructor(options = {}) {
    if (!instance) {
      try {
        this.settings = $.extend({}, defaults, options);

        this._debug('browserDetect: begin browserDetect init');

        //Accept user agent for testing, or get property from browser.  If ua was passed in (debug mode), disable caching
        this.settings.useSessionStorage = this.settings.userAgent ? false : this.settings.useSessionStorage;
        this.settings.ua = this.settings.userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : '');
        this.settings.platform = (typeof navigator !== 'undefined' ? navigator.platform : '');
        this.settings.boaBrowserShowNoticeCookie = spartaGlobalFunctions.spartaGetCookie('boaBrowserShowNotice');

        // Enable Test mode for dev by setting cookie, or this.settings.testMode=true
        this.settings.boaBrowserTestCookie = spartaGlobalFunctions.spartaGetCookie('boaBrowserTest');

        if (this.settings.boaBrowserTestCookie) {
          this.settings.testMode = true;
        }

        /* if testMode is on, check for cookie that enables browser msg, disable session storage. */
        if (this.settings.testMode) {
          this.settings.debug = true; // enable debug
          this.settings.showMessage = true; // show message on all pages
          this.settings.useSessionStorage = false; // don't use session storage
          this._debug(`browserDetect: testMode is: ${this.settings.testMode}`);
        }

        // Check local storage first
        this.boaBrowserObject = this._boaBrowserGetSessionStorage();

        // if browser obj found in localsession, just show message
        if (this.boaBrowserObject && this.boaBrowserObject.browserSupport) {
          // show browser message after doc ready.
          this._boaBrowserShowMessage();

          // set loaded complete flag
          this.boaBrowserObject.loaded = true;
          // set loaded complete flag
          spartaEventsUtility.pub(EVENTS.LOADED);

          // Not in session, create fresh browser object
        } else {
          // Define Default Browser Object
          this._boaBrowserGetDefaultObj((boaBrowserDefault) => {
            // Run bowser detection
            const bowser = this._bowserUtil(this.settings.ua);

            // merge bowser result with default browser object
            this.boaBrowserObject = $.extend(true, boaBrowserDefault, bowser);
            // Add system check data
            this._boaBrowserSystemCheck();

            // Add plugin check data
            this._boaBrowserPluginCheck();

            spartaStoreUtility.addData('browser', this.boaBrowserObject);

            // Browser Messaging Rules
            this._boaBrowserUpdateMessageData();

            this._debug('browserDetect: end browserDetect init');
            this._debug('this.boaBrowserObject');
            this._debug(this.boaBrowserObject);
          });
        }
      } catch (e) {
        this._debug(`browserDetect: _initialize error: ${e}`);
      }

      // Run debugging mode
      /* if (this.boaBrowserObject && this.boaBrowserObject.debug && typeof boaBrowserDebug === "function") {
        try {
          setTimeout(function () {
            boaBrowserDebug();
          }, 1000);
        } catch (e) {
          this._debug('browserDetect: _initialize error: ' + e);
        }
      } */
      instance = this;
    } else {
      return instance;
    }
  }

  get EVENTS() {
    return EVENTS;
  }

  /* Hide Browser Alert function */
  hideBrowserAlert() {
    this._debug('begin hideBrowserAlert()');
    this.settings.showMessage = false;
  }

  /* Debug function */
  _debug(msg) {
    if (window.console && this.settings.debug) {
      console.log(msg);
    }
  }

  /* Start Bowser detect function.
   * Bowser is a stand along utility providing browser & mobile device detection.  If bowswer is updated with new code,
   * it can easily be swapped out in bowserUtil without affecting any other logic */
  _bowserUtil(ua) {
    /*!
     * Bowser - a browser detector
     * https://github.com/ded/bowser
     * MIT License | (c) Dustin Diaz 2014
     */

    const t = true;

    function detect(ua) {
      function getFirstMatch(regex) {
        const match = ua.match(regex);
        return (match && match.length > 1 && match[1]) || '';
      }

      const iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase();
      const likeAndroid = /like android/i.test(ua);
      const android = !likeAndroid && /android/i.test(ua);
      const silk = /silk/i.test(ua);
      const sailfish = /sailfish/i.test(ua);
      const tizen = /tizen/i.test(ua);
      const webos = /(web|hpw)os/i.test(ua);
      const windowsphone = /windows phone/i.test(ua);
      const edgeVersion = getFirstMatch(/edg\/(\d+(\.\d+)?)/i);
      const versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i);
      const tablet = /tablet/i.test(ua);
      const mobile = !tablet && /[^-]mobi/i.test(ua);
      const windows = !windowsphone && /windows/i.test(ua);
      const mac = !iosdevice && !silk && /macintosh/i.test(ua);
      const linux = !android && /linux/i.test(ua);
      let result;

      if (/googlebot|bingbot|ysearch\/slurp|facebookexternalhit|twitterbot|BofASpider/i.test(ua)) {
        result = {
          name: 'Crawler/Bot',
          crawler: t,
        };
      } else if (/opera|opr/i.test(ua)) {
        result = {
          name: 'Opera',
          opera: t,
          version: versionIdentifier || getFirstMatch(/(?:opera|opr)[\s\/](\d+(\.\d+)?)/i),
        };
      } else if (windowsphone) {
        result = {
          name: 'Windows Phone',
          vendor: 'Microsoft',
          windowsphone: t,
          msie: t,
        };

        if (edgeVersion) {
          result.msedge = t;
          result.version = edgeVersion;
        } else {
          result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i);
        }
      } else if (/maxthon/i.test(ua)) {
        result = {
          name: 'Maxthon',
          maxthon: t,
          version: getFirstMatch(/maxthon\/(\d+(\.\d+)?)/i),
        };
      } else if (/chrom.+? edg/i.test(ua)) {
        result = {
          name: 'Edge',
          vendor: 'Microsoft',
          msie: t,
          edge: t,
          msedge: t,
          version: edgeVersion,
        };
      } else if (/msie|trident/i.test(ua)) {
        result = {
          name: 'Internet Explorer',
          vendor: 'Microsoft',
          msie: t,
          version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i),
        };
      } else if (/chrome|crios|crmo/i.test(ua)) {
        result = {
          name: 'Chrome',
          vendor: 'Google',
          chrome: t,
          version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i),
        };
      } else if (iosdevice) {
        result = {
          name: iosdevice === 'iphone' ? 'iPhone' : iosdevice === 'ipad' ? 'iPad' : 'iPod',
          vendor: 'Apple',
        };
        //  version is not part of user agent in web apps
        if (versionIdentifier) {
          result.version = versionIdentifier;
        }
      } else if (/sailfish/i.test(ua)) {
        result = {
          name: 'Sailfish',
          sailfish: t,
          version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i),
        };
      } else if (/seamonkey\//i.test(ua)) {
        result = {
          name: 'SeaMonkey',
          seamonkey: t,
          version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i),
        };
      } else if (/firefox|iceweasel/i.test(ua)) {
        result = {
          name: 'Firefox',
          vendor: 'Mozilla',
          firefox: t,
          version: getFirstMatch(/(?:firefox|iceweasel)[ \/](\d+(\.\d+)?)/i),
        };
        if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
          result.firefoxos = t;
        }
      } else if (/silk/i.test(ua)) {
        result = {
          name: 'Silk',
          vendor: 'Amazon',
          silk: t,
          version: getFirstMatch(/silk\/(\d+(\.\d+)?)/i),
        };
      } else if (android) {
        result = {
          name: 'Android',
          vendor: 'Google',
          version: versionIdentifier,
        };
      } else if (/phantom/i.test(ua)) {
        result = {
          name: 'PhantomJS',
          phantom: t,
          version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i),
        };
      } else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
        result = {
          name: 'BlackBerry',
          blackberry: t,
          version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i),
        };
      } else if (/(web|hpw)os/i.test(ua)) {
        result = {
          name: 'WebOS',
          webos: t,
          version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i),
        };

        if (/touchpad\//i.test(ua)) {
          result.touchpad = t;
        }
      } else if (/bada/i.test(ua)) {
        result = {
          name: 'Bada',
          bada: t,
          version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i),
        };
      } else if (/tizen/i.test(ua)) {
        result = {
          name: 'Tizen',
          tizen: t,
          version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier,
        };
      } else if (/safari/i.test(ua)) {
        result = {
          name: 'Safari',
          vendor: 'Apple',
          safari: t,
          version: versionIdentifier,
        };
      } else {
        result = {};
      }

      // set webkit or gecko flag for browsers based on these engines
      if (!result.msedge && /(apple)?webkit/i.test(ua)) {
        if (/(apple)?webkit\/537\.36/i.test(ua)) {
          result.name = result.name || 'Blink';
          result.blink = t;
        } else {
          result.name = result.name || 'Webkit';
          result.webkit = t;
        }
        if (!result.version && versionIdentifier) {
          result.version = versionIdentifier;
        }
      } else if (!result.opera && /gecko\//i.test(ua)) {
        result.name = result.name || 'Gecko';
        result.gecko = t;
        result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i);
      }

      // set OS flags for platforms that have multiple browsers
      if (!result.msedge && (android || result.silk)) {
        result.android = t;
      } else if (iosdevice) {
        result[iosdevice] = t;
        result.ios = t;
      } else if (mac) {
        result.mac = t;
      } else if (windows) {
        result.windows = t;
      } else if (linux) {
        result.linux = t;
      }

      // OS version extraction
      let osVersion = '';
      if (result.windowsphone) {
        osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
      } else if (iosdevice) {
        osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
        osVersion = osVersion.replace(/[_\s]/g, '.');
      } else if (android) {
        osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
      } else if (result.webos) {
        osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
      } else if (result.blackberry) {
        osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
      } else if (result.bada) {
        osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
      } else if (result.tizen) {
        osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
      }
      if (osVersion) {
        result.osversion = osVersion;
      }

      // device type extraction
      const osMajorVersion = osVersion.split('.')[0];

      if (tablet || iosdevice === 'ipad' || result.silk || (android && (osMajorVersion === 3 || (osMajorVersion === 4 && !mobile)))) {
        result.tablet = t;
      } else if (mobile || iosdevice === 'iphone' || iosdevice === 'ipod' || android ||
        result.blackberry || result.webos || result.bada) {
        result.mobile = t;
      }

      return result;
    }

    // End bower detect
    // Return the results of the Bowser detect function.
    return detect(ua);
  }
  // End bowser function

  /**
   * Check if browser TLS version is supported.
   * @returns {Boolean} True if TLS is supported (or detection failed), false if not.
   */
  _isSupportedTlsVersion() {
    const isSupportedWhenTlsDetectionFails = true;
    const tlsCookieValue = spartaGlobalFunctions.spartaGetCookie(TLS_COOKIE_NAME);

    if (!tlsCookieValue) return isSupportedWhenTlsDetectionFails;

    const tlsVersionString = tlsCookieValue.replace(TLS_COOKIE_VALUE_VERSION_PREFIX, '');

    if (!tlsVersionString) return isSupportedWhenTlsDetectionFails;

    const tlsVersion = parseFloat(tlsVersionString);

    if (isNaN(tlsVersion)) return isSupportedWhenTlsDetectionFails;

    return tlsVersion >= MIN_SUPPORTED_TLS_VERSION;
  }

  // system check
  _boaBrowserSystemCheck() {
    // detect platform by looking at platform or ua
    const p = this.settings.platform || this.settings.ua;
    const boaBrowserObject = this.boaBrowserObject;
    if (boaBrowserObject) {
      if (p.indexOf('Win') > -1) {
        boaBrowserObject.win = true;
      } else if (p.indexOf('Mac') > -1) {
        boaBrowserObject.mac = true;
      } else if (p.indexOf('X11') > -1 || p.indexOf('Linux') > -1) {
        boaBrowserObject.linux = true;
      } else {
        boaBrowserObject.win = true; // default win
      }
      // Find win, mac & linux that was not identified as mobile by Bowser
      boaBrowserObject.desktop = (!boaBrowserObject.mobile && !boaBrowserObject.tablet && (boaBrowserObject.win ||
        boaBrowserObject.mac || boaBrowserObject.linux));
    }


    // detect windows operating systems
    if (boaBrowserObject.win) {
      if (/Win(?:dows )?([^do]{2})\s?(\d+\.\d+)?/.test(this.settings.ua)) {
        if (RegExp['$1'] === 'NT') {
          switch (RegExp['$2']) {
            case '5.0':
              boaBrowserObject.osversion = '2000';
              break;
            case '5.1':
              boaBrowserObject.osversion = 'XP';
              break;
            case '6.0':
              boaBrowserObject.osversion = 'Vista';
              break;
            case '6.1':
              boaBrowserObject.osversion = 'Windows 7';
              break;
            case '6.2':
              boaBrowserObject.osversion = 'Windows 8';
              break;
            case '10.0':
              boaBrowserObject.osversion = 'Windows 10';
              break;
            default:
              boaBrowserObject.osversion = '';
              break;
          }
          // Windows Phone
        } else if (RegExp['$1'] === 'Ph') {
          if (/Windows Phone OS.?(\d+\.\d+)?/.test(this.settings.ua)) {
            boaBrowserObject.osversion = RegExp['$1'];
          }
        } else if (RegExp['$1'] === '9x') {
          boaBrowserObject.osversion = 'ME';
        } else {
          boaBrowserObject.osversion = RegExp['$1'];
        }
      }
    }
    // console.log(boaBrowserObject);
    return boaBrowserObject;
  }

  /* Browser plugin detection */
  _boaBrowserPluginCheck() {
    const plugins = {};

    // plugin detection - doesn't work in IE
    function hasPlugin(name) {
      name = name.toLowerCase();

      for (let i = 0; i < navigator.plugins.length; i += 1) {
        if (navigator.plugins[i].name.toLowerCase().indexOf(name) > -1) {
          return true;
        }
      }
      return false;
    }

    // plugin detection for IE
    function hasIEPlugin(name) {
      try {
        new ActiveXObject(name);

        return true;
      } catch (ex) {
        return false;
      }
    }

    // detect flash for all browsers
    function hasFlash() {
      let r = hasPlugin('Flash');
      if (!r) {
        r = hasIEPlugin('ShockwaveFlash.ShockwaveFlash');
      }
      return r;
    }

    // detect quicktime for all browsers
    function hasQuickTime() {
      let r = hasPlugin('QuickTime');
      if (!r) {
        r = hasIEPlugin('QuickTime.QuickTime');
      }
      return r;
    }

    try {
      plugins.flash = hasFlash();
      plugins.quicktime = hasQuickTime();
      this.boaBrowserObject.plugins = plugins;
    } catch (err) {}
    // end plugin check

    return;
  }

  // TODO - Reimplement this at some point
  // Make AJAX request to get latest browser content and rules
  _boaBrowserUpdateMessageData() {
    this._debug('start _boaBrowserUpdateMessageData');
    // Check if we should ajax in new browser rules
    // if local, skip ajax unless testMode is on in localhost since it wont exist
    if (!this.settings.useAjax ||
      (this.settings.isLocal &&
        (window.location.protocol === 'file:' || !this.settings.testMode)
      )) {
      this._boaBrowserProcessRules();
      this.boaBrowserObject.loaded = true;
      spartaEventsUtility.pub(EVENTS.LOADED, {});
      return;
    }

    $.ajax({
      type: 'GET',
      // url: "/content/enhanced-splash/js/browserDataCMS.js",
      url: '/globals/utilities/browser-support/1.0.0/browserData.json',
      dataType: 'script',
      cache: true,

      success: function (data, textStatus, jqxhr) {
        try {
          // CMS data loaded successfully
          if (typeof boaBrowserSupportCMS !== 'undefined' && boaBrowserSupportCMS.content) {
            // update browser obj
            this.boaBrowserObject.browserSupport = boaBrowserSupportCMS;

            // tag this obj as coming from CMS
            this.boaBrowserObject.browserSupport.source = 'cms';

            //    settings.showMessage =
            //        boaBrowserSupportCMS.showMessage;

            // Run rules for this browser
            this._boaBrowserProcessRules();

            // save obj to session storage
            this._boaBrowserSetSessionStorage();

            this.boaBrowserObject.loaded = true;
            $document.trigger('spartaBrowserObjectLoaded');
          }
        } catch (e) {
          this._debug(`browserDetect:_boaBrowserUpdateMessageData: ajax error: ${e}`);
        }
      },
    });
  }

  // Run Browser Message Rules & update browser object
  _boaBrowserProcessRules() {
    this._debug('browserDetect: begin _boaBrowserProcessRules');

    // Run Browser Rules
    const userMsg = this.boaBrowserObject.browserSupport.rules(this.boaBrowserObject);

    // if there is a message, sync up global object
    if (userMsg && userMsg.rule) {
      this.boaBrowserObject.userNotice = userMsg;
    }
    // Once rules are processed, Show message to user.  Have to do this here to ensure ajax call is complete.  Only do this after DOM ready.
    this._boaBrowserShowMessage();
  }

  /* Check the properties that would suppress the browser message.
  Skip if cookie found for msg previously closed || JS var boaBrowserShowNotice == false || URL Param boaBrowserShowNotice == false */
  _checkShowMessage() {
    try {
      // Don't show browser alert for local work unless in testMode
      if (this.settings.isLocal && !this.settings.testMode) {
        this._debug('Working in local module / localhost, suppress browser alert');
        return false;
      }
    } catch (e) {
      this._debug(`browserDetect: _checkShowMessage error: ${e}`);
    }

    if (!this.settings.showMessage || this.settings.boaBrowserShowNoticeCookie === 'false' ||
      (typeof boaBrowserShowNotice !== 'undefined' && boaBrowserShowNotice === false) ||
      spartaGlobalFunctions.getUrlParam('boaBrowserShowNotice') === 'false') {
      return false;
    }

    this._debug('_checkShowMessage OK to show message.');
    return true;
  }

  /* Display browser notification message after doc.ready. */
  _boaBrowserShowMessage() {
    this._debug('in _boaBrowserShowMessage');
    // die if showMessage is off

    // Check show message again after doc ready
    this.settings.showMessage = this._checkShowMessage();

    if (!this.settings.showMessage) {
      this._debug('showMessage is false');
      return;
    }

    let link;
    let currentBrowserInfo = '';
    const b = this.boaBrowserObject;
    const loc = window.location.hostname;

    b.url = b.browserSupport.url || {};

    // Set link based on env
    if (/(cert|qa|sit).*\.bankofamerica\.com$/.test(loc)) {
      link = b.browserSupport.url.cert;
    } else if (/(dev).*\.bankofamerica\.com$/.test(loc)) {
      link = b.browserSupport.url.dev;
    } else {
      link = b.browserSupport.url.prod;
    }

    link += b.userNotice.link;

    // Check if there is a message to show
    if (b.userNotice && b.userNotice.rule && b.userNotice.rule !== 'supportedBrowser' && b.userNotice.rule !== 'mobileBrowser') {
      if (b.name.length > 0 && b.version.length > 0) {
        currentBrowserInfo = `${b.browserSupport.content.misc.current} ${b.name} ${b.version}<br>`;
      }

      const { style, msg, btnText } = b.userNotice;
      const { closeText } = b.browserSupport.content.misc;

      const notice = b.browserSupport.template.replace('{currentBrowserInfo}', '')
        .replace('{style}', style)
        .replace('{msg}', msg)
        .replace('{link}', link)
        .replace('{btnText}', btnText)
        .replace('{closeText}', closeText)
        .replace('{msg-icon-sprite-fsd-source}', b.browserSupport.sprites.message);

      $('[data-sparta-container]:first').find('div:first').before(notice);

      if (b.userNotice.isCloseButtonVisible) {
        $('#browserUpgradeNoticeBarClose').show();
      }

      // if user closes the message, don't show again for this session.
      $('#browserUpgradeNoticeBarClose').click(() => {
        $('#browserUpgradeNoticeBar').hide();
        spartaGlobalFunctions.spartaSetCookie('boaBrowserShowNotice', false);
      });
    }
  }

  /* check for local storage & retrieve browser obj */
  _boaBrowserGetSessionStorage() {
    if (this.settings.useSessionStorage && window.sessionStorage.getItem('settings')) {
      this.settings = JSON.parse(window.sessionStorage.getItem('settings'));

      if (this.settings.boaBrowserObject) {
        return this.settings.boaBrowserObject;
      }
    }
    return false;
  }

  /* Define Default Browser Object */
  _boaBrowserGetDefaultObj(callbackFn) {
    const notSupportedTlsVersion = !this._isSupportedTlsVersion();

    const boaBrowserDefault = {
      loaded: false,
      ua: this.settings.ua,
      debug: this.settings.debug,
      // graded support - used in bowser
      a: false,
      c: false,
      x: false,

      // user agent names
      msie: false,
      edge: false,
      chrome: false,
      firefox: false,
      safari: false,
      opera: false,
      android: false,
      ios: false,
      iosdevice: false,
      ipad: false,
      iphone: false,
      ipod: false,
      blackberry: false,
      silk: false,
      crawler: false,

      // user agent details
      name: '',
      vendor: '',
      version: '',
      webkit: false,
      gecko: false,

      // device & system, plugins info
      tablet: false,
      mobile: false,
      desktop: false,
      win: false,
      mac: false,
      linux: false,
      osversion: '',
      windowsphone: false,
      plugins: {
        flash: false,
        quicktime: false,
      },

      // Placeholder for user messaging
      userNotice: {
        rule: '',
        msg: '',
        link: '',
      },

      // default browser support buckets & content.  Kill switch: showMessage = false;
      browserSupport: {
        rules: function (b) {
          let userMsg;
          /* Mobile Browsers */
          if (b.mobile || b.tablet || b.crawler) {
            /* no message for any mobile device or bot/crawler */
            userMsg = b.browserSupport.content.mobileBrowser;

            /* Blocked versions */
          } else if ((b.msie && b.version <= VERSIONS.BLOCKED_IE) || (b.firefox && b.version <= VERSIONS.BLOCKED_FF)) {
            userMsg = b.browserSupport.content.unsupportedBlocked;
          } else if (!(b.win && b.msie) && !b.chrome && !(b.win && b.firefox) && !(b.mac && b.safari)) {
            userMsg = b.browserSupport.content.unsupportedBrowserType;
            /* Deprecated! Support End of Life for these browser versions.  */
          } else if (
            (b.msie && b.version <= VERSIONS.EOL_IE) || // msie
            (b.chrome && b.version <= VERSIONS.EOL_CHROME) || // chrome
            (b.firefox && b.version <= VERSIONS.EOL_FF) || // firefox
            (b.safari && b.version <= VERSIONS.EOL_SAFARI)) { // safari
            userMsg = b.browserSupport.content.unsupportedEndOfLife;

            /* Supported, but outdated browser versions, recommend upgrade
                    } else if (
                        (b.chrome && b.version <= 35) || //chrome 20+
                        (b.firefox && b.version <= 30) || //fireforx 20+
                        (b.safari && b.version <= 6)) //safari 6+ {

                        userMsg = b.browserSupport.content.supportedUpgradeVersion;
                        */
          } else if (notSupportedTlsVersion) {
            userMsg = b.browserSupport.content.unsupportedTlsVersion;
          } else {
            userMsg = b.browserSupport.content.supportedBrowser;
          }

          return userMsg;
        },
        template: `
          <div id='browserUpgradeNoticeBar' class='{style}'>
            <div class='row'>
              <div class='column small-11'>
                <div class='msg-icon-sprite-fsd'><span class='ada-hidden'>warning-icon</span></div>
                <div class='msg-container'>
                    <span class='msg-text'>{currentBrowserInfo}{msg}<a target='_blank' href='{link}' name='boaBrowserInfoBtn' id='boaBrowserInfoBtn' class='browser-upgrade-now'>{btnText}</a></span>
                </div>
              </div>
              <div class='column small-1' style='line-height: 18px;'>
                <a id='browserUpgradeNoticeBarClose' class='spa-ui-layer-close' style='top:0; left:0;' href='javascript:void(0);'><span class='close-text ada-hidden'>{closeText} browser upgrade notice</span> <span class='spa-close-x' aria-hidden='true'>×</span></a>
              </div>
            </div>
            <style>
              #browserUpgradeNoticeBar {padding: 10px 0;} 
              #browserUpgradeNoticeBarClose .close-fsd {display: inline-block; position: relative; top: 4px;}  
              #browserUpgradeNoticeBar.hide-close #browserUpgradeNoticeBarClose {display:none;} 
              #browserUpgradeNoticeBar .msg-container { font-size: 14px; line-height: 24px; float: left; padding-left: 10px; } 
              #browserUpgradeNoticeBar .msg-icon-sprite-fsd { background: url('{msg-icon-sprite-fsd-source}') no-repeat scroll 0 0 transparent; display: inline-block; float: left;} 
              #browserUpgradeNoticeBar .browser-upgrade-now {margin-left: 10px;} 
              #browserUpgradeNoticeBar.boa-browser-1 { background-color: #FFF4F9; border-bottom: 1px solid #E31838; } 
              #browserUpgradeNoticeBar.boa-browser-1 .msg-icon-sprite-fsd {background-position: -70px 0;height:24px;width:24px;} 
              #browserUpgradeNoticeBar.boa-browser-2 { background-color: #FFF5D7; border-bottom: 1px solid #FC7800; } 
              #browserUpgradeNoticeBar.boa-browser-2 .msg-icon-sprite-fsd {background-position: -70px -240px;height:24px;width:24px;}
            </style>
          </div>`,
      },
    };

    if (!this.importTriggered) {
      this.loadBrowserData().then((xhr) => {
        boaBrowserDefault.browserSupport = Object.assign({}, boaBrowserDefault.browserSupport, xhr.browserSupport);
        this.importTriggered = true;
        callbackFn(boaBrowserDefault);
      });
    } else {
      callbackFn(boaBrowserDefault);
    }
  }

  loadBrowserData() {
    const lang = spartaStoreUtility.getData('lang').split('-')[0];

    // generate a new DataAssetLoader instance
    const messagingAssetLoader = new DataAssetLoader('global/sparta-browser-support-utility', `data/${lang}`);

    // load the relevant messages JSON file, which triggers success and failure events so that the utility can subscribe to them
    const load = messagingAssetLoader.loadAsset('browser.json');

    // generate a promise with the results from our event subscription so we can
    // return the name of the file that was actually loaded
    // this serves mostly as an example of how to deal with this
    const assetLoaderPromise = new Promise((resolve) => {
      // subscribe to the event emitted by the DataAssetLoader
      // we use true for the retroactive parameter to make sure that even if we miss
      // the initial event firing due to it happening quicker than expected, we can
      // still respond to it
      spartaEventsUtility.sub(load.success, (evtData) => {
        // define the messageList object from the messages.json file
        resolve(evtData.data.xhr);
      }, true);
    });

    spartaEventsUtility.sub(load.failure, (evtData) => {
      // log out an error for debugging the issue
      if (window.console && console.warn) {
        console.warn(`Sparta Browser Support: ${evtData.data.filename} AJAX Error.`, evtData.data.xhr);
      }
    }, true);

    return assetLoaderPromise;
  }

  /** _setBrowserCSS - Set Browser CSS classes in HTML based on Browser obj */
  addBrowserClasses() {
    let uaClassesStr = '';
    const uaClasses = [];
    const classPrefix = 'spa-ua-';
    const b = this.boaBrowserObject || {};

    // class for device
    switch (true) {
      case b.desktop:
        uaClasses.push('desktop');
        break;
      case b.tablet:
        uaClasses.push('tablet');
        break;
      case b.mobile:
        uaClasses.push('mobile');
        break;
    }

    // class for browser
    switch (true) {
      case b.msie:
        uaClasses.push('browser-msie');
        break;
      case b.firefox:
        uaClasses.push('browser-firefox');
        break;
      case b.chrome:
        uaClasses.push('browser-chrome');
        break;
      case b.safari:
        uaClasses.push('browser-safari');
        break;
      case b.opera:
        uaClasses.push('browser-opera');
        break;
      case b.silk:
        uaClasses.push('browser-silk');
        break;
      default:
        uaClasses.push('browser-other');
    }

    if (b.version) {
      uaClasses.push(`browser-version-${parseInt(b.version, 10)}`);
    }

    // class for os / device / system type
    switch (true) {
      case b.mac:
        uaClasses.push('system-mac');
        break;
      case b.ios:
        uaClasses.push('system-ios');

        switch (true) {
          case b.ipad:
            uaClasses.push('system-ipad');
            break;
          case b.iphone:
            uaClasses.push('system-iphone');
            break;
          case b.ipod:
            uaClasses.push('system-ipod');
            break;
          default:
            break;
        }
        break;
      case b.android:
        uaClasses.push('system-android');
        break;
      case b.windowsphone:
        uaClasses.push('system-windowsphone');
        break;
      case b.blackberry:
        uaClasses.push('system-blackberry');
        break;
      case b.win:
        uaClasses.push('system-win');
        break;
      default:
        uaClasses.push('system-other');
    }

    for (let i = 0; i < uaClasses.length; i += 1) {
      uaClassesStr += `  ${classPrefix}${uaClasses[i]}`;
    }

    $('html').addClass(uaClassesStr);
  }
}

export default new SpartaBrowserSupportUtility();

